export default {
  elevation1: {
    marginLeft: "3px",
    boxShadow: "0px 2px 6px 0px rgba(0.34,0.34,0.34,0.2)",
    "@media (max-width:500px)": {
      marginLeft: "0"
    }
  }
};
